import { clone } from '@/common/js/just.js'

/**
 * @description: 打开修改计划头像昵称弹窗
 * @param {*} rowIndex // 单条修改时的行索引
 * @return {*}
 */
export function onProfileModify(rowIndex) {
  // 点击单行时设置check状态
  if (!Object.is(Number(rowIndex), NaN)) {
    this.tableData = this.tableData.map((row, index) => {
      return { ...row, profileCheck: index === rowIndex }
    })
  } else {
    if (!this.tableData.some((row) => row.profileCheck)) {
      return this.$Message.warning('请选择修改行')
    }
  }

  // 保存当前需要更改的行，如果是全选更改，那么保存第一个
  this.currentModifyTableRow = clone(this.tableData[rowIndex || 0])

  this.modal.showGlobalProfileModify = true
}

/**
 * @description: 更换头像昵称确认
 * @return {*}
 */
export function onProfileModifyConfirm(info, brandType) {
  const { brand_id, image_id, profile_id, promoted_object_id } = info

  // 只有3.0有品牌形象
  if (brand_id && image_id) {
    this.tableData = this.tableData.map((row) => {
      if (row.profileCheck) {
        const newRow = clone(row)
        newRow.creative.components.brand.brandInfo = info
        newRow.creative.components.brand.brandType = brandType
        newRow.creative.components.brand.profileInfo = {}
        newRow.creative.components.wechat_channels.channelInfo = {}
        return newRow
      }
      return row
    })
  }
  if (promoted_object_id) {
    this.tableData = this.tableData.map((row) => {
      if (row.profileCheck) {
        const newRow = clone(row)
        newRow.creative.components.wechat_channels.channelInfo = info
        newRow.creative.components.brand.brandType = brandType
        newRow.creative.components.brand.brandInfo = {}
        newRow.creative.components.brand.profileInfo = {}
        return newRow
      }
      return row
    })
  }
  if (!brand_id && profile_id) {
    // ada 和 v3.0 处理profile_id
    this.tableData = this.tableData.map((row) => {
      if (row.profileCheck) {
        const newRow = clone(row)

        // 腾讯广告3.0的头像昵称
        if (this.pageStates.isV3) {
          newRow.creative.components.brand.profileInfo = info
          newRow.creative.components.brand.brandInfo = {}
          newRow.creative.components.wechat_channels.channelInfo = {}
          newRow.creative.components.brand.brandType = brandType
        } else {
          newRow.creative.profile = info
        }
        return newRow
      }
      return row
    })
  }

  this.onModifyModalCancel()
}
